<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Statut d'emploi</legend>

        <!-- Block Statut emploi -->
        <div>
          <!-- Informations Statut emploi -->
          <div>
            <div v-if="!isDroitsAcquis">
              <RessourceInfoBulle code="RE-SE-1" />
              <RessourceInfoBulle code="RE-SE-2" />

              <p class="font-weight-bold mb-0">
                Veuillez sélectionner votre situation parmi les quatre choix suivants
                <span class="cssRequired" /> :
              </p>

              <v-container fluid>
                <v-radio-group v-model="statutDEmploiRadio" :rules="rules.statutDEmploi" required @change="statutEmploiChange">
                  <!-- v-expansion-panels commence sa numérotation à 0 -->
                  <v-expansion-panels :value="statutEmploiSection - 1">
                    <!-- 1 -->
                    <v-expansion-panel focusable>
                      <v-expansion-panel-header>
                        J'ai un emploi (à temps plein, à temps partiel ou occasionnel) au Québec dans le domaine du travail social, de la thérapie
                        conjugale et familiale ou dans un domaine apparenté.
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-radio :value="$catalogues.statutDEmploi.enEmploi">
                          <template v-slot:label>
                            <div>
                              <span class="font-weight-bold">En emploi – dans le domaine </span>: poursuivre mon inscription au taux régulier.
                            </div>
                          </template>
                        </v-radio>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- 2 -->
                    <v-expansion-panel focusable>
                      <v-expansion-panel-header>
                        J'ai un emploi (à temps plein, à temps partiel ou occasionnel) au Québec dans un autre domaine.
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-radio :value="$catalogues.statutDEmploi.autreDomaine">
                          <template v-slot:label>
                            <div>
                              <span class="font-weight-bold">En emploi – dans un autre domaine</span> : poursuivre mon inscription au taux régulier.
                            </div>
                          </template>
                        </v-radio>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- 3 -->
                    <v-expansion-panel focusable>
                      <v-expansion-panel-header>
                        <div>
                          J'ai un emploi (à temps plein, à temps partiel ou occasionnel) et je veux demander
                          <span class="font-weight-bold text-decoration-underline">un taux préférentiel</span>. Veuillez justifier votre demande en
                          sélectionnant un choix.
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <template>
                          <v-radio :value="$catalogues.statutDEmploi.horsQuebec">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">En emploi - hors Québec </span>: je travaille exclusivement à l'extérieur du Québec.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.enEmploiCommunautaire">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">En emploi (exclusivement d'un organisme communautaire)</span> : je travaille
                                exclusivement pour un ou plusieurs organisme(s) communautaire(s) au Québec, financé(s) par l'un des programmes de
                                soutien financier gouvernemental (Action Communautaire, Action Communautaire Autonome, Défense Collective des Droits, 
                                Centre d'Aide & de Lutte Contre les Agressions à Caractère Sexuel), ou, membre d'un des regroupements reconnus par l'Ordre 
                                (<a
                                  href="https://www.otstcfq.org/membres/statut-demploi/#1674056644058-567a6531-f93c"
                                  target="_blank"
                                  @click.stop
                                  >consultez les critères d'admissibilité</a
                                >). Une attestation de l'organisme sera demandée au membre.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.congesMaternite">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">Congé parental</span> : je suis présentement en congé parental, sans aucune rémunération pendant
                                une période ininterrompue d'un minimum de 
                                <span class="font-weight-bold">26 semaines</span>. Ce tarif est offert une fois par parent pour chaque naissance ou adoption.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.congesDivers">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">Congés divers</span> : Je ne reçois aucune rémunération pendant une période ininterrompue d'un minimum
                                 de <span class="font-weight-bold">26 semaines</span>, pour 
                                <span class="font-weight-bold">un congé de maladie ou sans solde</span>.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.etudeTempsPleinAvecRevenu" class="mb-0">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold"
                                  >Étudiant à la maîtrise à temps plein ou au doctorat en travail social ou thérapie conjugale et familiale avec
                                  rémunération</span
                                >
                                : je travaille et je suis étudiant à la maîtrise à temps plein en travail social ou en thérapie conjugale et familiale
                                ou au doctorat en travail social depuis moins de 4 ans (avec preuve d'étude).
                              </div>
                            </template>
                          </v-radio>

                          <!-- Affichage lien clickable pour le dernier cas -->
                          <div v-if="statutDEmploiRadio === $catalogues.statutDEmploi.etudeTempsPleinAvecRevenu" class="ml-8 v-label theme--light">
                            Veuillez fournir une preuve d'étude au service à la clientèle par ce
                            <a target="_blank" :href="urlSaqRequest">formulaire web</a>.
                          </div>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- 4 -->
                    <v-expansion-panel focusable>
                      <v-expansion-panel-header>
                        <div>
                          Je suis présentement sans emploi, et je veux demander
                          <span class="font-weight-bold text-decoration-underline">un taux préférentiel</span>. Veuillez sélectionner votre situation.
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <template>
                          <v-radio :value="$catalogues.statutDEmploi.sansEmploi">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">Sans emploi</span> : je suis présentement sans emploi, sans aucune rémunération.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.benevolat">
                            <template v-slot:label>
                              <div><span class="font-weight-bold">Bénévolat</span> : je suis bénévole, sans aucune rémunération.</div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.etudeTempsPleinSansRevenu">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">Étudiant sans aucune rémunération</span> : je suis étudiant à temps partiel ou temps
                                plein, sans aucune rémunération.
                              </div>
                            </template>
                          </v-radio>
                          <v-radio :value="$catalogues.statutDEmploi.retraitePlus10ans">
                            <template v-slot:label>
                              <div>
                                <span class="font-weight-bold">Retraité</span> : J'ai 55 ans ou plus, je bénéficie d'une rente ou d'un revenu de
                                retraite quelconque <span class="font-weight-bold">ET</span>
                                j'ai cessé toute activité professionnelle ou fonction relevant de l'exercice de la profession de T.S. ou de T.C.F.
                              </div>
                            </template>
                          </v-radio>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-radio-group>
              </v-container>
            </div>

            <!-- Droits acquis -->
            <div v-else>
              <RessourceInfoBulle code="RE-SE-3" />
              <v-autocomplete
                v-model="statutEmploi.statutDEmploi"
                :item-text="itemText"
                :item-value="itemValue"
                :items="listeStatutDEmploi"
                :rules="rules.statutDEmploi"
                class="cssRequired"
                label="Statut d'emploi"
                required
                return-object
                @change="statutEmploiChange"
              ></v-autocomplete>
            </div>
          </div>

          <template v-if="isTSouTCFstatutMembreOuAutoriseASInscrire">
            <v-autocomplete
              v-if="isPrecisionStatutRequired"
              v-model="statutEmploi.precisionStatut"
              :class="isPrecisionStatutRequired && 'cssRequired'"
              :item-text="itemText"
              :item-value="itemValue"
              :items="listePrecisionsStatutFilter"
              :required="isPrecisionStatutRequired"
              :rules="rules.precisionStatut"
              label="Précision statut"
              return-object
              @change="precisionStatutChange"
            ></v-autocomplete>

            <v-text-field
              v-model="statutEmploi.complementPrecisionStatut"
              :class="isComplementPrecisionRequired && 'cssRequired'"
              :required="isComplementPrecisionRequired"
              :rules="rules.complementPrecisionStatut"
              label="Complément précision statut"
            ></v-text-field>

            <!-- Dates de congés -->
            <div v-if="isConges" class="d-flex">
              <div class="mr-6">
                <v-menu
                  ref="menuDebutConge"
                  v-model="debutCongeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="290px"
                  offset-y
                  required
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-sheet max-width="200">
                      <v-text-field
                        v-model="statutEmploi.dateDebutConges"
                        v-mask="'####-##-##'"
                        :rules="rules.dateDebutConges"
                        append-icon="mdi-calendar"
                        class="cssRequired"
                        hint="Format YYYY-MM-DD"
                        label="Date début congés"
                        readonly
                        required
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-sheet>
                  </template>
                  <v-date-picker
                    :max="statutEmploi.dateFinDeCongesSiConnue"
                    ref="debutCongePicker"
                    v-model="statutEmploi.dateDebutConges"
                    required
                    @change="saveDebutConge"
                  />
                </v-menu>
              </div>
              <div>
                <v-menu
                  ref="menuFinConge"
                  v-model="finCongeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="290px"
                  offset-y
                  required
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-sheet max-width="200">
                      <v-text-field
                        v-model="statutEmploi.dateFinDeCongesSiConnue"
                        v-mask="'####-##-##'"
                        :rules="rules.dateFinDeCongesSiConnue"
                        append-icon="mdi-calendar"
                        class="cssRequired"
                        hint="Format YYYY-MM-DD"
                        label="Date fin congés"
                        readonly
                        required
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-sheet>
                  </template>
                  <v-date-picker
                    :min="statutEmploi.dateDebutConges"
                    ref="finCongePicker"
                    v-model="statutEmploi.dateFinDeCongesSiConnue"
                    required
                    @change="saveFinConge"
                  />
                </v-menu>
              </div>
            </div>
          </template>
          <template v-if="isDroitsAcquis">
            <v-checkbox v-model="statutEmploi.membreDUnAutreOrdre" label="Membre d'un autre ordre ?" @change="membreDUnAutreOrdreChange"></v-checkbox>
            <v-text-field v-if="statutEmploi.membreDUnAutreOrdre" v-model="statutEmploi.specifier" label="Spécifier"></v-text-field>

            <v-checkbox
              v-model="statutEmploi.detenezVousUnBaccOuMaitriseEnTS"
              label="Détenez-vous un baccalauréat ou une maîtrise en travail social?"
              @change="detenezVousUnBaccOuMaitriseEnTSChange"
            ></v-checkbox>

            <div v-if="statutEmploi.detenezVousUnBaccOuMaitriseEnTS">
              <v-menu
                ref="menuDateObtention"
                v-model="dateObtentionMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                autocomplete="off"
                min-width="290px"
                offset-y
                required
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-sheet max-width="200">
                    <v-text-field
                      v-model="statutEmploi.dateObtention"
                      v-mask="'####-##-##'"
                      :rules="rules.dateObtention"
                      append-icon="mdi-calendar"
                      class="cssRequired"
                      hint="Format YYYY-MM-DD"
                      label="Date d'obtention"
                      readonly
                      required
                      v-bind="attrs"
                      v-on="on"
                    />
                  </v-sheet>
                </template>
                <v-date-picker
                  ref="dateObtentionPicker"
                  v-model="statutEmploi.dateObtention"
                  :max="new Date().toISOString().substring(0, 10)"
                  required
                  @change="saveDateObtention"
                />
              </v-menu>
              <v-text-field v-model="statutEmploi.universite" label="Université"></v-text-field>
            </div>
          </template>
        </div>
      </fieldset>

      <fieldset>
        <legend class="text-h6 text-sm-h5">Lieu(x) de travail</legend>

        <RessourceInfoBulle code="RE-SE-4" />
        <div v-if="!isSansEmploi" class="legalSection section-margin">
          <p class="mentionLegal" style="font-weight: bold">
            Avez-vous un autre lieu de travail ?
            <v-btn color="primary" @click="ajouter()">Ajouter</v-btn>
          </p>
        </div>

        <v-expansion-panels ref="panels" v-model="panel" class="section-margin" focusable>
          <CarteDAffairePro
            v-for="item in listeAdressesPro"
            :key="item.internalIndex"
            :item="item"
            :valid="valid"
            @adressePrincipaleUnique="adressePrincipaleUnique"
            @edition="dupliquerPourEdition"
            @openDialog="openDialog"
            @validate-form="validateForm"
          >
          </CarteDAffairePro>
        </v-expansion-panels>

        <section v-if="!isSansEmploi && listeAdressesPro.length === 0" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="RE-SE-5" />
        </section>
        <section v-if="isSansEmploi && listeAdressesPro.length > 0" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="RE-SE-6" />
        </section>
        <section v-else-if="listeAdressesPro.length > 0 && !valid && isHeaderValid" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="RE-SE-7" />
        </section>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid || !isAdressesValid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>

    <v-dialog v-model="dateFinDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline"> Fin de fonction ou désactivation </v-card-title>
        <div v-if="dateMinDialog === null">
          <v-card-text class="subtitle-1"> Vous devez renseigner une date de début avant de pouvoir supprimer votre lieu de travail. </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="cancelDialog"> Retour </v-btn>
          </v-card-actions>
        </div>
        <div v-else>
          <v-card-text class="subtitle-1">
            Vous êtes sur le point de supprimer votre lieu de travail. Merci d'indiquer la date de fin et valider.
          </v-card-text>
          <v-card-text class="subtitle-1">
            <v-menu
              ref="menuDateFin"
              v-model="dateFinMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              autocomplete="off"
              min-width="200px"
              offset-y
              required
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-sheet>
                  <v-text-field
                    v-model="dateFinValue"
                    v-mask="'####-##-##'"
                    append-icon="mdi-calendar"
                    class="cssRequired"
                    hint="Format YYYY-MM-DD"
                    label="Date de fin"
                    readonly
                    required
                    v-bind="attrs"
                    v-on="on"
                  />
                </v-sheet>
              </template>
              <v-date-picker ref="dateFinPicker" v-model="dateFinValue" :min="dateMinDialog" required @change="saveDateFin" />
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="cancelDialog"> Annuler </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteRow(deletingLieuxDeTravail)"> Valider </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "../Loader"
import CarteDAffairePro from "../common/CarteDAffairePro"
import { isDroitsAcquis, isTsOuTcfStatutMembreOuAutoriseASInscrire } from "@/utils/autorisationHelper"
import NavigationPageFormulaireInscriptionMixin from "@/mixins/navigationPageFormulaireInscriptionMixin"
import { getExtranetUrl, getSacUrl } from "@/utils/stringUtils"

export default {
  mixins: [NavigationPageFormulaireInscriptionMixin],
  props: {
    routeName: {
      type: String,
      default: ""
    }
  },
  components: {
    Loader: Loader,
    CarteDAffairePro
  },
  data() {
    return {
      urlEspaceFormationLara: getExtranetUrl(process.env.VUE_APP_FORMATION_XTRANET),
      overlay: false,
      messageSelector: "",
      valid: true,
      panel: null,
      dateFinDialog: false,
      dateFinMenu: false,
      dateFinValue: null,
      deletingLieuxDeTravail: null,
      dateMinDialog: null,
      debutCongeMenu: false,
      finCongeMenu: false,
      dateObtentionMenu: false,
      statutDEmploiRadio: null,
      statutEmploiSection: null,
      rules: {
        statutDEmploi: [(v) => !!v || "Le statut d'emploi est requis"],
        precisionStatut: [(v) => !this.isPrecisionStatutRequired || !!v || "La précision du statut est requise"],
        complementPrecisionStatut: [(v) => !this.isComplementPrecisionRequired || !!v || "Le complément de précision est requis"],
        dateDebutConges: [(v) => !this.isConges || !!v || "La date de début de congés est requise"],
        dateFinDeCongesSiConnue: [(v) => !this.isConges || !!v || "La date de fin de congés est requise"],
        dateObtention: [(v) => !!v || "La date d'obtention est requise"]
      }
    }
  },
  created() {
    this.fetchItems()
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      demandeInscriptionPpId: "DemandeInscription/GET_CONTACTID",
      cartesDAffaires: "CarteDAffaire/getCartesDAffaires",
      getAutorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      getStatutsEmploi: "Catalogue/getStatutsEmploi",
      getPrecisionsStatut: "Catalogue/getPrecisionsStatut"
    }),
    urlSaqRequest() {
      return getSacUrl(this.demandeInscriptionPpId)
    },
    isDroitsAcquis() {
      return isDroitsAcquis(this.getAutorisations)
    },
    listeAdressesPro() {
      return this.cartesDAffaires.filter((c) => c.active)
    },
    isTSouTCFstatutMembreOuAutoriseASInscrire() {
      return isTsOuTcfStatutMembreOuAutoriseASInscrire(this.getAutorisations)
    },
    isConges() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesDivers ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesMaternite
        )
      } else {
        return false
      }
    },
    isSansEmploi() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.sansEmploi ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.retraiteMoins10ans ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.retraitePlus10ans ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.etudeTempsPleinSansRevenu
        )
      }

      return false
    },
    listePrecisionsStatutFilter() {
      return this.getPrecisionsStatut.filter((p) => this.statutEmploi.statutDEmploi != null && p.parent == this.statutEmploi.statutDEmploi.id)
    },
    listeStatutDEmploi() {
      if (this.isDroitsAcquis) {
        return this.getStatutsEmploi.filter(
          (s) => s.id == this.$catalogues.statutDEmploi.enEmploi || s.id == this.$catalogues.statutDEmploi.sansEmploi
        )
      } else {
        return this.getStatutsEmploi
      }
    },
    isPrecisionStatutRequired() {
      if (this.statutEmploi.statutDEmploi) {
        return this.listePrecisionsStatutFilter.length > 0
      } else {
        return false
      }
    },
    isComplementPrecisionRequired() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.autreDomaine ||
          (this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesDivers &&
            this.statutEmploi.precisionStatut &&
            this.statutEmploi.precisionStatut.id == this.$catalogues.precisionStatutDEmploi.autre)
        )
      }

      return false
    },
    isAdressesValid() {
      if (this.isSansEmploi) {
        return this.hasAdressesActive === false
      }

      return this.hasPlusieursAdressesPrincipales === false && this.hasAdressesActive
    },
    hasPlusieursAdressesPrincipales() {
      return this.cartesDAffaires.filter((c) => c.principalPro === true).length > 1
    },
    hasAdressesActive() {
      return this.listeAdressesPro.length > 0
    },
    isHeaderValid() {
      let result = true

      for (const key in this.rules) {
        let rule = this.rules[key]

        if (rule instanceof Array) {
          rule = rule[0]
        }

        result = result && rule(this.statutEmploi[key]) === true
      }

      return result
    }
  },
  methods: {
    ...mapMutations({
      addCarteDAffaire: "CarteDAffaire/addCarteDAffaire",
      removeCarteDAffaire: "CarteDAffaire/removeCarteDAffaire"
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getDefaultCarteDAffairePro: "CarteDAffaire/getDefaultCarteDAffairePro",
      fetchCartesDAffairesProByContactId: "CarteDAffaire/fetchCartesDAffairesProByContactId",
      createCarteDAffaire: "CarteDAffaire/createCarteDAffaire",
      updateCarteDAffaire: "CarteDAffaire/updateCarteDAffaire",
      createOrganisation: "Organisation/createOrganisation",
      getAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi"
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.pays),
          this.getCatalogue(this.$cataloguesDesc.province),
          this.getCatalogue(this.$cataloguesDesc.fonction),
          this.getCatalogue(this.$cataloguesDesc.heuresPratiqueAutonome),
          this.getCatalogue(this.$cataloguesDesc.adapteHandicape),
          this.getCatalogue(this.$cataloguesDesc.domaineDePratique),
          this.getCatalogue(this.$cataloguesDesc.typeClientele),
          this.getCatalogue(this.$cataloguesDesc.methodeIntervention),
          this.getCatalogue(this.$cataloguesDesc.approcheIntervention),
          this.getCatalogue(this.$cataloguesDesc.serviceOffert),
          this.getCatalogue(this.$cataloguesDesc.typeTherapie),
          this.getCatalogue(this.$cataloguesDesc.typeActiviteReservee),
          this.getCatalogue(this.$cataloguesDesc.typeProbleme),
          this.getCatalogue(this.$cataloguesDesc.serviceReferenceEnLigne),
          this.getCatalogue(this.$cataloguesDesc.statutEmploi),
          this.getCatalogue(this.$cataloguesDesc.precisionStatutEmploi)
        ]

        if (this.demandeInscriptionPpId) {
          requests.push(this.fetchCartesDAffairesProByContactId(this.demandeInscriptionPpId))
        }

        if (this.demandeInscriptionId) {
          requests.push(this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId))
          requests.push(this.getAutorisationDePratiqueByDemandeInscriptionId(this.demandeInscriptionId))
        }

        await Promise.all(requests)

        // hack pour l'affichage du radio
        // Initialisation de l'affichage radio du statut d'emploi.
        this.statutDEmploiRadio = this.statutEmploi?.statutDEmploi?.id
        // Section à ouvrir
        this.statutEmploiSection = this.getStatutEmploiSection(this.statutDEmploiRadio)

        this.validateForm(true)
        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    getStatutEmploiSection(statutEmploi) {
      const statutsSection = {}
      statutsSection[this.$catalogues.statutDEmploi.enEmploi] = 1
      statutsSection[this.$catalogues.statutDEmploi.autreDomaine] = 2
      statutsSection[this.$catalogues.statutDEmploi.horsQuebec] = 3
      statutsSection[this.$catalogues.statutDEmploi.enEmploiCommunautaire] = 3
      statutsSection[this.$catalogues.statutDEmploi.retraiteMoins10ans] = 3 // valeur historique
      statutsSection[this.$catalogues.statutDEmploi.retraitePlus10ans] = 3 // todo: gestion doublon group 3 et 4
      statutsSection[this.$catalogues.statutDEmploi.congesMaternite] = 3
      statutsSection[this.$catalogues.statutDEmploi.congesDivers] = 3
      statutsSection[this.$catalogues.statutDEmploi.etudeTempsPleinAvecRevenu] = 3
      statutsSection[this.$catalogues.statutDEmploi.sansEmploi] = 4
      statutsSection[this.$catalogues.statutDEmploi.benevolat] = 4
      statutsSection[this.$catalogues.statutDEmploi.etudeTempsPleinSansRevenu] = 4
      statutsSection[this.$catalogues.statutDEmploi.retraiteMoins10ans] = 4 // valeur historique
      statutsSection[this.$catalogues.statutDEmploi.retraitePlus10ans] = 4 // todo: gestion doublon group 3 et 4

      return statutsSection[statutEmploi] ?? null
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form.validate() && this.isAdressesValid

      if (resetValidation) {
        this.$refs.form.resetValidation()
      }
    },
    saveAndContinue() {
      this.save()
    },
    async save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.validateForm()

      if (this.valid && this.cartesDAffaires != null) {
        for (const carteDAffaire of this.cartesDAffaires) {
          if (this.demandeInscriptionId) {
            carteDAffaire.demandeInscription = this.demandeInscriptionId
          }

          if (this.demandeInscriptionPpId) {
            carteDAffaire.pp = this.demandeInscriptionPpId
          }

          if (!carteDAffaire.pm && carteDAffaire.organisation && !carteDAffaire.organisation.id) {
            carteDAffaire.organisation.statutEmployeur = {
              id: process.env.VUE_APP_ORGANISME_STATUT_NONVALIDEE
            }
            carteDAffaire.pm = await this.createOrganisation(carteDAffaire.organisation)
          }

          // set de la date de fin de la carte d'affaire précédente, TODO -1 jour ?
          if (carteDAffaire.cartePrecedente && carteDAffaire.dateDEntreeEnFonction) {
            carteDAffaire.cartePrecedente.dateDeFinDeFonction = carteDAffaire.dateDEntreeEnFonction
          }

          if (carteDAffaire.id == null) {
            await this.createCarteDAffaire(carteDAffaire)
          } else {
            // Permet de désactiver les cartes modifiées
            await this.updateCarteDAffaire(carteDAffaire)
          }
        }

        await this.updateStatutEmploi(this.statutEmploi)

        this.next()
      } else {
        this.$refs.panels.$el.scrollIntoView({ behavior: "smooth" })
      }
      this.overlay = false
    },
    async dupliquerPourEdition(carteDAffaire) {
      if (!carteDAffaire) {
        return
      }

      const clone = Object.assign({}, carteDAffaire)
      carteDAffaire.active = false
      clone.id = null
      clone.cartePrecedente = carteDAffaire // hook pour la gestion de la date de fin

      this.adressePrincipaleUnique(clone)

      await this.ajouter(clone)
    },
    async ajouter(carte = null) {
      if (!this.cartesDAffaires) {
        return
      }

      const carteDAffaire = carte || (await this.getDefaultCarteDAffairePro())
      carteDAffaire.pp = this.demandeInscriptionPpId
      carteDAffaire.demandeInscription = this.demandeInscriptionId
      carteDAffaire.internalIndex = this.cartesDAffaires.length

      if (carte === null) {
        carteDAffaire.pratiqueAutonome = this.getPratiqueAutonomeSelonStatutEmploi()
      }

      this.addCarteDAffaire(carteDAffaire)

      // Ouverture de la carte pour saisie
      this.$nextTick(() => {
        this.panel = this.listeAdressesPro.length - 1
      })
    },
    deleteRow(item) {
      this.removeCarteDAffaire({ item: item, dateFin: this.dateFinValue })

      this.cancelDialog()
      this.validateForm()
    },
    saveDateFin(date) {
      this.$refs.menuDateFin.save(date)
    },
    openDialog(item) {
      if (item.id === null && item.cartePrecedente == null) {
        this.deleteRow(item)

        return
      }

      if (item.dateDEntreeEnFonction != null) {
        this.dateMinDialog = item.dateDEntreeEnFonction
      }

      this.deletingLieuxDeTravail = item
      this.dateFinDialog = true
    },
    cancelDialog() {
      this.deletingLieuxDeTravail = null
      this.dateMinDialog = null
      this.dateFinValue = null
      this.dateFinDialog = false
    },
    adressePrincipaleUnique(item) {
      if (item.principalPro === true) {
        this.cartesDAffaires.filter((c) => c.id != item.id).forEach((c) => (c.principalPro = false))
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    saveDateObtention(date) {
      this.$refs.menuDateObtention.save(date)
    },
    saveDebutConge(date) {
      this.$refs.menuDebutConge.save(date)
    },
    saveFinConge(date) {
      this.$refs.menuFinConge.save(date)
    },
    precisionStatutChange() {
      this.setPratiqueAutonomeCarteCreation()
    },
    setPratiqueAutonomeCarteCreation() {
      const nombreCarteDAffaire = this.listeAdressesPro.length

      if (nombreCarteDAffaire === 1) {
        const carteDAffaire = this.listeAdressesPro[0]
        const pratiqueAutonome = this.getPratiqueAutonomeSelonStatutEmploi()

        // Mise à jour de la carte d'affaire en cours de création
        if (carteDAffaire.id == null && pratiqueAutonome) {
          carteDAffaire.pratiqueAutonome = pratiqueAutonome
        }
      }
    },
    getPratiqueAutonomeSelonStatutEmploi() {
      if (this.statutEmploi.statutDEmploi && this.statutEmploi.precisionStatut) {
        return (
          this.statutEmploi.statutDEmploi.id === this.$catalogues.statutDEmploi.enEmploi &&
          this.statutEmploi.precisionStatut.id === this.$catalogues.precisionStatutDEmploi.pratiqueAutonome
        )
      }

      return false
    },
    statutEmploiChange() {
      if (this.statutDEmploiRadio && !this.isDroitsAcquis) {
        this.statutEmploi.statutDEmploi = this.getStatutsEmploi.find((s) => s.id === this.statutDEmploiRadio)
      }

      this.statutEmploi.precisionStatut = null
      this.validateForm(true)
    },
    membreDUnAutreOrdreChange() {
      if (!this.statutEmploi.membreDUnAutreOrdre) {
        this.statutEmploi.specifier = null
        this.validateForm(true)
      }
    },
    detenezVousUnBaccOuMaitriseEnTSChange() {
      if (!this.statutEmploi.detenezVousUnBaccOuMaitriseEnTS) {
        this.statutEmploi.dateObtention = null
        this.statutEmploi.universite = null
        this.validateForm(true)
      }
    }
  }
}
</script>

<style></style>